import { rowsBaseSelectors } from './rowsBaseSelectors'

export const rowsSelectors = {
  ...rowsBaseSelectors
}
